<template>
  <div>
    <div>
      <div
        v-if="page === 'Details'"
        class="status-panel"
        style="border-left: 10px solid #7F7F7F"
      >
        <div class="is-flex">
          <div
            class="is-flex flex-align--center"
            style="padding-right: 1rem;"
          >
            <div
              class="icon-color"
              style="margin: 1rem; font-size: 12px;"
            >
              <font-awesome-icon
                size="3x"
                :icon="['fas', 'question-circle']"
              />
            </div>
            <div class="is-flex flex-direction--column flex-align--start">
              <div
                class="status-panel--header"
                style="color: #000"
              >
                Review Shared Identifiers
              </div>
              <div
                class="subtext-font-size"
                style="color: #666"
              >
                Review the shared identifiers group.
              </div>
            </div>
          </div>
          <div
            class="is-flex flex-align--center grow"
            style="border-left: 1px solid #ccc; padding-left: 1rem;"
          >
            <div
              v-if="personTypeMisMatched
                || differentPersonType
                || cannotSplit
                || dataAccessPermission
                || dataAccessPermissionNearMatch"
            >
              <font-awesome-icon
                :icon="['fas', 'exclamation-triangle']"
                size="3x"
                style="color: #ffc107!important"
              />
            </div>
            <div
              class="subtext-font-size"
              style="padding-left: 1rem; color: #666"
            >
              <span v-if="personTypeMisMatched">
                The identifier split request is not authorized.
                The identifier is not the same person type and cannot be split.
              </span>
              <span v-if="differentPersonType">
                User is not authorized to submit records to the specified
                person type: Person Type={{ diffPersonType.toString() }}
              </span>
              <span v-if="cannotSplit">
                No History records exist for this Person Record
                (State ID {{ idToSplit }}). This identifier cannot be split.
              </span>
              <span
                v-if="dataAccessPermission || dataAccessPermissionNearMatch"
                v-html="formattedDataAccessErrorMessage"
              ></span>
            </div>
          </div>
          <div class="is-flex">
            <div class="status-panel--actions
              is-flex
              flex-direction--column
              flex-justify--center
              flex-align--start
              subtext-font-size"
            >
              <a @click="returnToSplitHome" tabindex="0" role="button">
                {{ shareId ? 'Cancel and Return to List' : 'Cancel' }}
              </a>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="page === 'Review'"
        class="status-panel"
        style="border-left: 10px solid #ED7D31"
      >
        <div class="is-flex">
          <div
            class="is-flex flex-align--center"
            style="padding-right: 1rem;"
          >
            <div
              class="icon-color"
              style="margin: 1rem; font-size: 12px;"
            >
              <font-awesome-icon
                size="3x"
                :icon="['fas', 'exclamation-circle']"
              />
            </div>
            <div class="is-flex flex-direction--column flex-align--start">
              <div
                class="status-panel--header"
                style="color: #000"
              >
                Pending Split ID Request
              </div>
              <div
                class="subtext-font-size"
                style="color: #666"
              >
                All split requests are final and cannot be reverted.
              </div>
              <div
                class="subtext-font-size"
                style="color: #000000"
              >
                <span style="color: #666" >
                  ID
                </span>
                {{ idToSplit }}
                <span style="color: #666" >
                  will be split into one or more new identifiers as shown below.
                </span>
              </div>
            </div>
          </div>
        <div
          class="is-flex flex-align--center grow"
          style="padding-left: 1rem;"
        >
        </div>
        <div class="is-flex">
          <div class="status-panel--actions
            is-flex
            flex-direction--column
            flex-justify--center
            flex-align--start
            subtext-font-size"
          >
            <a @click="returnToSplitHome" tabindex="0" role="button">
              {{ shareId ? 'Cancel and Return to List' : 'Cancel' }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="page === 'Confirm'"
      class="status-panel"
      style="border-left: 10px solid #28A745"
    >
      <div class="is-flex">
        <div
          class="is-flex flex-align--center"
          style="padding-right: 1rem;"
        >
          <div
            class="icon-color"
            style="margin: 1rem; font-size: 12px;"
          >
            <font-awesome-icon
              size="3x"
              :icon="['fas', 'check-circle']"
            />
            </div>
            <div class="is-flex flex-direction--column flex-align--start">
              <div
                class="status-panel--header"
                style="color: #000"
              >
                Identifier Split / Separated
              </div>
              <div
                class="subtext-font-size"
                style="color: #666"
              >
                All split requests are final and cannot be reverted.
              </div>
              <div
                class="subtext-font-size"
                style="color: #000000"
              >
                <span style="color: #666" >
                  Retained Identifier:
                </span>
                {{ formatStateID(idToSplit) }}
              </div>
              <div
                class="subtext-font-size"
                style="color: #000000"
              >
                <span style="color: #666" >
                  New Identifier:
                </span>
                {{ formatStateID(newId) }}
              </div>
              <div
                class="subtext-font-size"
                style="color: #000000"
              >
                <span style="color: #666" >
                  Reason for Split:
                </span>
                {{ splitReason }}
              </div>
            </div>
          </div>
          <div
            class="is-flex flex-align--center grow"
            style="padding-left: 1rem;"
          >
          </div>
          <div class="is-flex">
            <div class= "status-panel--actions
              is-flex
              flex-direction--column
              flex-justify--center
              flex-align--start
              subtext-font-size"
            >
              <a @click="returnToSplitHome" tabindex="0" role="button">
                {{
                  splitConfirmed
                    ? 'Return to List'
                    : (shareId
                        ? 'Cancel and Return to List'
                        : 'Cancel')
                }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faQuestionCircle,
} from '@fortawesome/pro-solid-svg-icons';
import NotificationManager from '@/mixins/NotificationManager';
import StateIdUtils from '@/mixins/StateIdUtils';

library.add(
  faCheckCircle,
  faExclamationCircle,
  faExclamationTriangle,
  faQuestionCircle,
);

export default {
  mixins: [
    NotificationManager,
    StateIdUtils,
  ],
  props: {
    cannotSplit: {
      type: Boolean,
    },
    idToSplit: {
      type: String,
    },
    diffPersonType: {
      type: String,
    },
    dataAccessErrorMessage: {
      type: String,
    },
    dataAccessPermission: {
      type: Boolean,
    },
    dataAccessPermissionNearMatch: {
      type: Boolean,
    },
    differentPersonType: {
      type: Boolean,
    },
    newId: {
      type: String,
    },
    page: {
      type: String,
    },
    personTypeMisMatched: {
      type: Boolean,
    },
    splitConfirmed: {
      type: Boolean,
    },
    splitReason: {
      type: String,
    },
  },
  data() {
    return {
      shareId: false, // True if the user navigated to the current page from Share Id Search page
    };
  },
  created() {
    this.shareId = this.$route.query.shareId;
  },
  computed: {
    formattedDataAccessErrorMessage() {
      if (!this.dataAccessErrorMessage) return this.dataAccessErrorMessage;
      let msg = this.dataAccessErrorMessage;
      // Create PersonID links
      msg = msg.replace(/PersonID: ([\d, ]+)/g, (_, ids) => {
        const links = ids.split(',').map((id) => {
          const trimmed = id.trim();
          return `<a href="/uid/personid/individualMatch/${trimmed}/details" target="_blank">${trimmed}</a>`;
        }).join(', ');
        return `PersonID: ${links}`;
      });
      // Create DirectMatch links
      msg = msg.replace(/DirectMatch: ([\d, ]+)/g, (_, ids) => {
        const links = ids.split(',').map((id) => {
          const trimmed = id.trim();
          return `<a href="/uid/directMatch/transactions/${trimmed}/details" target="_blank">${trimmed}</a>`;
        }).join(', ');
        return `DirectMatch: ${links}`;
      });
      return msg;
    },
  },
  methods: {
    resetNotifications() {
      this.$store.state.notifications.isActive = false;
      this.$store.state.notifications.notificationType = null;
    },
    returnToSplitHome() {
      this.resetNotifications();
      if (this.shareId) {
        this.$router.go(-1); // navigate back to the Share Id Search page
      } else {
        this.$router.push({
          name: 'PISplitId',
        });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.icon-color
    color: #BBBBBB
.max-char
    max-width: 200ch
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
.status-panel
    border: 1px solid #bbb
    background-color: #f9f9f9
    box-shadow: 0 0 3px #aaa
    padding: 12px 16px 12px 0
.status-panel--header
    font-size: 20px
    margin-bottom: 0.25rem
.status-panel--actions
    border-left: 1px solid #ccc
    padding-left: 1rem
.subtext-font-size
    font-size: 12px
</style>
